/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateNoteUpdatePathParams,
	CandidateNoteUpdateRequest,
	CandidateNoteUpdateResponse,
} from '../types/CandidateNoteUpdate'

/**
 * PATCH /candidates/:candidate/notes/:note
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::update
 */
export async function candidateNoteUpdate(
	candidate: CandidateNoteUpdatePathParams['candidate'],
	note: CandidateNoteUpdatePathParams['note'],
	data: CandidateNoteUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateNoteUpdateResponse>> {
	return axiosInstance.patch(`/candidates/${candidate}/notes/${note}`, data, config)
}
